import React from "react";
import Layout from "../../Layout/Layout.jsx";
import { withRouter } from "react-router";
import withStyles from "@material-ui/core/styles/withStyles";
import componentsStyle from "../../assets/jss/material-kit-react/views/components.jsx";
import SectionMaps from "./SectionMaps.jsx";
class DigitalMaps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      language: window.language.setLanguage(props.match.params.lang).components,
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      language: window.language.setLanguage(newProps.match.params.lang).components
    });
  }

  render() {
    return (
      <Layout language={this.state.language} color="white" {...this.props}>
        <SectionMaps
          {...this.state.language}
          lang={this.state.language.lang}
        />
      </Layout>
    );
  }
}

export default withRouter(withStyles(componentsStyle)(DigitalMaps));



// WEBPACK FOOTER //
// ./src/views/Publications/DigitalMaps.jsx